import React from "react";
import { useNavigate } from "react-router-dom";
import { supportPageContent as content } from "../content/supportPageContent";
import "./PrivacyPolicyPage.css";
import "./SupportPage.css";

const SupportPage = () => {
  const navigate = useNavigate();
  const { contact, faq, featureRequests, bugReports, development } = content;

  return (
    <main className="landing-legal-page support-page">
      <div className="landing-page-width">
        <article className="landing-legal-page__article">
          <h1 className="landing-legal-page__title">{content.title}</h1>
          <p className="support-page__subtitle">{content.subtitle}</p>
          <p>{content.description}</p>

          <section>
            <h2>{contact.title}</h2>
            <p>
              Email us at{" "}
              <a href={`mailto:${contact.email}`}>{contact.email}</a>.
            </p>
            <p>{contact.responseTime}</p>
          </section>

          <section className="support-page__faq">
            <h2>{faq.title}</h2>
            <div className="support-page__faq-list">
              {faq.items.map((item) => (
                <details key={item.question} className="support-page__faq-item">
                  <summary>{item.question}</summary>
                  <p>{item.answer}</p>
                </details>
              ))}
            </div>
          </section>

          <section>
            <h2>{featureRequests.title}</h2>
            <p>{featureRequests.description}</p>
            <p>
              Send your ideas to{" "}
              <a href={`mailto:${contact.email}`}>{contact.email}</a>.
            </p>
          </section>

          <section>
            <h2>{bugReports.title}</h2>
            <p>{bugReports.description}</p>
            <ul>
              {bugReports.requirements.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p>
              Report issues to{" "}
              <a href={`mailto:${contact.email}`}>{contact.email}</a>.
            </p>
          </section>

          <section>
            <h2>{development.title}</h2>
            <p>{development.description}</p>
          </section>
        </article>
      </div>

      <div className="landing-cobalt-pagefoot">
        <div className="landing-page-width landing-page-width--ruled-top">
          <div className="landing-cobalt-pagefoot__inner">
            <span>© {new Date().getFullYear()} InvestX</span>
            <div className="landing-cobalt-pagefoot__links">
              <button type="button" onClick={() => navigate("/")}>
                Home
              </button>
              <button type="button" onClick={() => navigate("/support")}>
                Support
              </button>
              {content.footer.links.map((link) => (
                <button
                  key={link.url}
                  type="button"
                  onClick={() => navigate(link.url)}
                >
                  {link.title}
                </button>
              ))}
              <button type="button" onClick={() => navigate("/delete-account")}>
                Delete account
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default SupportPage;
